/**
 * 把商品级的库存总数平均分摊到各规格。
 *
 * 后台商品列表显示的「库存」是单门店各规格库存之和，而编辑弹窗只有一个库存输入框，
 * 所以多规格商品保存时按规格平均分摊；余数补给靠前的规格，保证各规格之和严格等于输入值，
 * 即「输入多少，列表就显示多少」。运营要单独给某个规格调数时，仍可去库存管理页按行改。
 */
export function splitStockAcrossSkus(total: number | null | undefined, skuCount: number): number[] {
  const count = Math.max(0, Math.trunc(Number(skuCount) || 0))
  if (count === 0) {
    return []
  }
  const amount = Math.max(0, Math.trunc(Number(total) || 0))
  const base = Math.floor(amount / count)
  const remainder = amount - base * count

  const parts: number[] = []
  for (let index = 0; index < count; index += 1) {
    parts.push(base + (index < remainder ? 1 : 0))
  }
  return parts
}
